export default [
    {
        path: '/admin/academic/evaluation-examinations',
        name: 'evaluation-examination',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/evaluation-examination/index.vue')
    },
    {
        path: '/admin/academic/evaluation-examinations/create',
        name: 'evaluation-examination-create',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/evaluation-examination/create.vue')
    },
]

